module.exports = __webpack_public_path__ + "da20b1f4fcd3509b81e7addc52543140.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SD.svg
// module id = fizj
// module chunks = 0